import Popover from '@components/v2/ui/Popover/Popover';
import { Breakpoint, PopoverOrigin, SxProps, Theme } from '@mui/material';
import { CSSProperties, ReactNode } from 'react';

type ToolbarPopoverWidth =
  | CSSProperties['width']
  | Partial<Record<Breakpoint, CSSProperties['width']>>;

interface ToolbarPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  children: ReactNode;
  testId?: string;
  width?: ToolbarPopoverWidth;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  paperSx?: SxProps<Theme>;
}

const DEFAULT_ANCHOR_ORIGIN: PopoverOrigin = { vertical: 'bottom', horizontal: 'left' };
const DEFAULT_WIDTH: ToolbarPopoverWidth = { xs: 'auto', sm: 240 };

const ToolbarPopover = ({
  open,
  anchorEl,
  onClose,
  children,
  testId,
  width = DEFAULT_WIDTH,
  anchorOrigin = DEFAULT_ANCHOR_ORIGIN,
  transformOrigin,
  paperSx,
}: ToolbarPopoverProps) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      testId={testId}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      slotProps={{
        paper: {
          sx: [
            (theme) => ({
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              overscrollBehavior: 'none',
              maxHeight: '500px',
              padding: theme.spacing(1.25, 0, 0.5, 1.25),
              marginTop: theme.spacing(1),
              borderRadius: `${theme.shape.borderRadius2xl}px`,
              border: `1px solid ${theme.palette.custom.border.primary}`,
              width,
            }),
            ...(Array.isArray(paperSx) ? paperSx : paperSx ? [paperSx] : []),
          ],
        },
      }}
    >
      {children}
    </Popover>
  );
};

export default ToolbarPopover;
